var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo1188({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 120.5,
    viewBox: "0 0 111 120.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.g{fill:#fff;}.b{fill:#19141e;}.b,.c,.d,.e,.f,.g,.i{fill-rule:evenodd;}.c{fill:#f2bfe4;}.d{opacity:0.399;}.e{fill:#405fd3;}.f{fill:#0d0b6d;}.h,.i{fill:none;stroke:#252535;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-616.7 -289)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(617 299.286)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 55.5,
    cy: 55,
    rx: 55.5,
    ry: 55,
    transform: "translate(-0.3 0.214)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(629.343 289)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M144.808,80.918c0,9.831-6.321,17.8-14.118,17.8s-14.117-7.969-14.117-17.8,6.321-17.8,14.117-17.8,14.118,7.969,14.118,17.8",
    transform: "translate(-62.694 -50.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M86.7,155.2l-.59-20.444s24.787,1.978,30.089-.782c0,0,6.481-33.464-1.249-52l-.156-.722L62.491,75.129l-2.932,30.083C57.8,100,43.255,94.1,39.454,101.556,31.216,117.718,60.67,128.6,60.67,128.6l-2.991,26.848",
    transform: "translate(-38 -54.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M100.506,160.446l-16.714-3.592,16.634,11.261Z",
    transform: "translate(-52.392 -80.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M127.127,118.443l5.775,14.152-6.922.088Z",
    transform: "translate(-65.651 -68.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M115.488,117.916a3.5,3.5,0,1,1-4.066-2.827,3.505,3.505,0,0,1,4.066,2.827",
    transform: "translate(-60.172 -67.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M143.792,117.916a3.5,3.5,0,1,1-4.066-2.827,3.505,3.505,0,0,1,4.066,2.827",
    transform: "translate(-69.067 -67.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.363,77.105c.193-4.166.773-5.6,23.322.128,31.523,8.012,43.087-23.526,30.655-30.73-3.445-2-7.03-.834-11.163.5-4.6,1.489-9.869,3.2-16.379,1.027-18.39-6.126-30.954-1.613-38.24,1.644-7.2,3.218-16.11,14.426-14.265,26.71a72.024,72.024,0,0,0,2.952,12.627A24.442,24.442,0,0,1,66.6,100.877C71.642,98.493,73.737,90.57,74.363,77.105Z",
    transform: "translate(-41.158 -45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M113.629,139.977a8.171,8.171,0,0,0,7.026,3.951Z",
    transform: "translate(-61.769 -74.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M113.629,139.977a8.171,8.171,0,0,0,7.026,3.951",
    transform: "translate(-61.769 -74.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M117.868,115.807a8.005,8.005,0,1,1-8.006-8.022A8.013,8.013,0,0,1,117.868,115.807Z",
    transform: "translate(-58.07 -64.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M147.262,115.807a8.005,8.005,0,1,1-8-8.022A8.013,8.013,0,0,1,147.262,115.807Z",
    transform: "translate(-67.308 -64.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M128.715,120.026h-3.461",
    transform: "translate(-65.423 -68.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M92.795,119.484H73.021",
    transform: "translate(-49.007 -68.409)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo1188);
export default __webpack_public_path__ + "static/media/Grupo 1188.9dd5e7550d5c3e036b50227c6f433387.svg";
export { ForwardRef as ReactComponent };